// @flow
import {List, Map} from 'immutable';

export default function getQuestionDifficultyTotalsFromList(difficulties: List<*>) {
  return difficulties.reduce((prev, curr) => {
    prev = prev.set(curr.toString(), prev.get(curr.toString(), new List()).push(curr));
    return prev;
  }, new Map());
}
